const navigation = {
  solutions: [
    { name: "Mobile Development", href: "/service-mobile" },
    { name: "Web Development", href: "/service-web" },
    { name: "Data Engineering", href: "/service-data" },
    { name: "Business Plan", href: "/service-businessplan" },
    { name: "Benchmarking", href: "/service-benchmarking" },
    { name: "Strategy", href: "/service-strategy" },
  ],
  Contact: [
    { name: "Contact Us", href: "/contact2" },
    { name: "Join The Team", href: "/team" },
    { name: "Sign Up Beta", href: "/newhome" },
  ],
  company: [
    { name: "About", href: "" },
    { name: "Services", href: "/landing" },
    { name: "Team", href: "/team" },
    { name: "Software", href: "/software" },
    { name: "Past Projects", href: "/past-projects" },
  ],
  software: [
    { name: "Info", href: "/software" },
    { name: "software", href: "/newhome" },
    { name: "Sign Up Beta", href: "/newhome" },
  ],
  social: [
    {
      name: "Instagram",
      href: "https://www.instagram.com/innovation_studios_uk/",
      icon: (props) => (
        <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
          <path
            fillRule="evenodd"
            d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
            clipRule="evenodd"
          />
        </svg>
      ),
    },
    {
      name: "Linkedin",
      href: "https://www.linkedin.com/company/innovation-studios-uk",
      icon: (props) => (
        <img
          src="https://res.cloudinary.com/dl2adjye7/image/upload/v1696536481/icons8-linkedin_frdtcn.svg"
          alt="LinkedIn"
          {...props}
        />
      ),
    },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-white" aria-labelledby="footer-heading">
      <h2 id="footer-heading" className="sr-only">
        Footer
      </h2>
      <div className="mx-auto max-w-7xl px-6 pb-8 pt-16 sm:pt-24 lg:px-8 lg:pt-32">
        <div style={{ height: "1px", backgroundColor: "black" }}></div>
        <div className="xl:grid xl:grid-cols-3 xl:gap-8 mt-20">
          <div className="space-y-8">
            <img
              className="h-20"
              src="https://res.cloudinary.com/dl2adjye7/image/upload/v1696432884/Logos_512_x_512_px_192_x_192_px_abcxt1.png"
              alt="Innovation Studios"
            />
            <p className="text-sm leading-6 text-gray-600 text-left font-alliance">
              Bridging the gap between university and industry.
            </p>
            <div className="flex space-x-6">
              {navigation.social.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="text-gray-400 hover:text-gray-500"
                >
                  <span className="sr-only">{item.name}</span>
                  <item.icon className="h-6 w-6" aria-hidden="true" />
                </a>
              ))}
            </div>
          </div>
          <div className="mt-16 grid grid-cols-2 gap-8 xl:col-span-2 xl:mt-0">
            <div className="md:grid md:grid-cols-2 md:gap-8">
              <div>
                <h3 className="text-sm font-semibold leading-6 text-gray-900 text-left font-alliance">
                  Solutions
                </h3>
                <ul role="list" className="mt-6 space-y-4 text-left">
                  {navigation.solutions.map((item) => (
                    <li key={item.name}>
                      <a
                        href={item.href}
                        className="text-sm leading-6 text-gray-600 hover:text-gray-900 font-alliance"
                      >
                        {item.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="mt-10 md:mt-0">
                <h3 className="text-sm font-semibold leading-6 text-gray-900 text-left font-alliance">
                  Contact
                </h3>
                <ul role="list" className="mt-6 space-y-4 text-left">
                  {navigation.Contact.map((item) => (
                    <li key={item.name}>
                      <a
                        href={item.href}
                        className="text-sm leading-6 text-gray-600 hover:text-gray-900 font-alliance"
                      >
                        {item.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="md:grid md:grid-cols-2 md:gap-8">
              <div>
                <h3 className="text-sm font-semibold leading-6 text-gray-900 text-left font-alliance">
                  Company
                </h3>
                <ul role="list" className="mt-6 space-y-4 text-left">
                  {navigation.company.map((item) => (
                    <li key={item.name}>
                      <a
                        href={item.href}
                        className="text-sm leading-6 text-gray-600 hover:text-gray-900 font-alliance"
                      >
                        {item.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="mt-10 md:mt-0">
                <h3 className="text-sm font-semibold leading-6 text-gray-900 text-left font-alliance">
                  Software
                </h3>
                <ul role="list" className="mt-6 space-y-4 text-left">
                  {navigation.software.map((item) => (
                    <li key={item.name}>
                      <a
                        href={item.href}
                        className="text-sm leading-6 text-gray-600 hover:text-gray-900 font-alliance"
                      >
                        {item.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-16 border-t border-gray-900/10 pt-8 sm:mt-20 lg:mt-24">
          <p className="text-xs leading-5 text-gray-500 text-left font-alliance">
            &copy; 2023 Innovation Studios, Inc. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
